module.exports = __webpack_public_path__ + "static/media/HeatShape_Diamonds.c7dcf5ac.jpg";